module.exports = __webpack_public_path__ + "img/227a75b.png";